export const csvTemplateHeaders = [
  { label: 'SiteId', key: 'siteId' },
  {
    label: 'highSchool_ImplementationLevel',
    key: 'highSchool_ImplementationLevel',
  },
  {
    label: 'highSchool_ImplementationType',
    key: 'highSchool_ImplementationType',
  },
  { label: 'highSchool_IsLaunched', key: 'highSchool_IsLaunched' },
  {
    label: 'highSchool_StudentActivities',
    key: 'highSchool_StudentActivities',
  },
  {
    label: 'mspDigital_BullyingHarassmentUnitEnabled',
    key: 'mspDigital_BullyingHarassmentUnitEnabled',
  },
]



// WEBPACK FOOTER //
// ./src/containers/css-admin/sitePreferences/data.js